import React from "react";
import { makeStyles } from "@mui/styles";
import { fontSize, fontWeight, lineHeight } from "../../utils/constants/UI";

export const styles = makeStyles({
  root: {
    margin: 0,
    padding: 0,
    "& ul": {
      paddingLeft: "20px",
      margin: "8px 0",
    },
    "& ol": {
      paddingLeft: "20px",
      margin: "8px 0",
    },
    "& li": {
      marginBottom: "4px",
    },
    "& a": {
      color: "#1976d2",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    "& blockquote": {
      borderLeft: "4px solid #ddd",
      paddingLeft: "16px",
      margin: "8px 0",
      fontStyle: "italic",
      color: "#666",
    },
    "& code": {
      backgroundColor: "#f5f5f5",
      padding: "2px 4px",
      borderRadius: "4px",
      fontFamily: "monospace",
      fontSize: "0.9em",
    },
    "& pre": {
      backgroundColor: "#f5f5f5",
      padding: "12px",
      borderRadius: "4px",
      overflow: "auto",
      margin: "8px 0",
    },
    "& pre code": {
      backgroundColor: "transparent",
      padding: 0,
    },
  },
  micro: {
    fontSize: fontSize.MICRO,
    lineHeight: lineHeight.MICRO,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  xs: {
    fontSize: fontSize.XS,
    lineHeight: lineHeight.XS,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  sm: {
    fontSize: fontSize.SM,
    lineHeight: lineHeight.SM,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  md: {
    fontSize: fontSize.MD,
    lineHeight: lineHeight.MD,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  lg: {
    fontSize: fontSize.LG,
    lineHeight: lineHeight.LG,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  xl: {
    fontSize: fontSize.XL,
    lineHeight: lineHeight.XL,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  dxs: {
    fontSize: fontSize.DXS,
    lineHeight: lineHeight.DXS,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  dsm: {
    fontSize: fontSize.DSM,
    lineHeight: lineHeight.DSM,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  dlg: {
    fontSize: fontSize.DLG,
    lineHeight: lineHeight.DLG,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
  dxl: {
    fontSize: fontSize.DXL,
    lineHeight: lineHeight.DXL,
    fontWeight: (props) => props?.fontWeight || fontWeight.REGULAR,
    color: (props) => props?.color,
    whiteSpace: (props) => (props?.isEllipses || props?.isNoWrap) && "nowrap",
    overflow: (props) => props?.isEllipses && "hidden",
    textOverflow: (props) => props?.isEllipses && "ellipsis",
    wordBreak: (props) => !props?.isEllipses && "break-word",
    overflowWrap: "break-word",
  },
});

// Enhanced markdown parser
const parseMarkdown = (text) => {
  if (!text) return "";

  let html = text;

  // Bold text: **text** -> <strong>text</strong>
  html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

  // Italic text: *text* -> <em>text</em>
  html = html.replace(/\*(.*?)\*/g, "<em>$1</em>");

  // Code: `code` -> <code>code</code>
  html = html.replace(/`([^`]+)`/g, "<code>$1</code>");

  // Links: [text](url) -> <a href="url">text</a>
  html = html.replace(
    /\[([^\]]+)\]\(([^)]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  );

  // Unordered lists: - item -> <ul><li>item</li></ul>
  html = html.replace(/^- (.+)$/gm, "<li>$1</li>");
  html = html.replace(/(<li>.*<\/li>)/s, "<ul>$1</ul>");

  // Ordered lists: 1. item -> <ol><li>item</li></ol>
  html = html.replace(/^\d+\. (.+)$/gm, "<li>$1</li>");

  // Line breaks: \n -> <br>
  html = html.replace(/\n/g, "<br>");

  // Paragraphs: Double line breaks -> <p>
  html = html.replace(/<br><br>/g, "</p><p>");
  html = "<p>" + html + "</p>";

  // Clean up empty paragraphs
  html = html.replace(/<p><\/p>/g, "");
  html = html.replace(/<p><br><\/p>/g, "");

  return html;
};

const TypographyChat = ({
  size,
  color,
  label,
  fontWeight,
  isRequired = false,
  isEllipses = false,
  parseMarkdown: enableMarkdown = true,
  ...props
}) => {
  const classes = styles({ color, fontWeight, isEllipses });

  // Parse markdown if enabled
  const processedLabel = enableMarkdown ? parseMarkdown(label || "") : label;

  return (
    <div
      className={`${classes.root} ${classes[size]}`}
      {...props}
      dangerouslySetInnerHTML={{
        __html: `${processedLabel}${isRequired ? "*" : ""}`,
      }}
    />
  );
};

export default TypographyChat;
